import { Property } from "csstype"
import React, { CSSProperties, DOMAttributes, forwardRef, ReactElement } from "react"
import { HorizontalGroupCss, VerticalGroupCss } from "./style"

export interface GroupBaseProps {
	alignItems?: Property.AlignItems
	alignSelf?: Property.AlignSelf
	justifyContent?: Property.JustifyContent
	flex?: Property.Flex
	spacing?: number

	children: Array<ReactElement | undefined | false | "" | unknown>

	style?: CSSProperties
	className?: string
}

export type GroupProps = GroupBaseProps & DOMAttributes<HTMLDivElement>

interface BaseGroupProps extends GroupProps {
	flexDirection: Property.FlexDirection
}

export const Group = forwardRef<HTMLDivElement, BaseGroupProps & DOMAttributes<HTMLDivElement>>(
	(props, ref) => {
		const {
			alignItems,
			alignSelf,
			justifyContent,
			flex,
			spacing,
			flexDirection,
			children,
			style,
			className,
			...rest
		} = props
		return flexDirection === "row" || flexDirection === "row-reverse" ? (
			<HorizontalGroupCss
				spacing={spacing}
				style={{
					display: "flex",
					flexDirection,
					alignItems,
					alignSelf,
					justifyContent,
					flex,
					...style,
				}}
				className={className}
				ref={ref}
				{...rest}
			>
				{children}
			</HorizontalGroupCss>
		) : (
			<VerticalGroupCss
				spacing={spacing}
				style={{
					display: "flex",
					flexDirection,
					alignItems,
					alignSelf,
					justifyContent,
					flex,
					...style,
				}}
				className={className}
				ref={ref}
				{...rest}
			>
				{children}
			</VerticalGroupCss>
		)
	}
)

export const HorizontalGroup = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
	return <Group {...props} flexDirection="row" ref={ref} />
})

export const VerticalGroup = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
	return <Group {...props} flexDirection="column" ref={ref} />
})
